import { VALID_CLASS_GRADES } from 'src/constants/grades.constants';

export enum GRADES {
  IT = 'IT', // infant/toddler
  PR = 'PR', // preschool
  PK = 'PK', // pre-kindergarten
  TK = 'TK', // transitional kindergarten
  K = 'K',
  FIRST = '1',
  SECOND = '2',
  THIRD = '3',
  FOURTH = '4',
  FIFTH = '5',
  SIXTH = '6',
  SEVENTH = '7',
  EIGHTH = '8',
  NINTH = '9',
  TENTH = '10',
  ELEVENTH = '11',
  TWELFTH = '12',
  THIRTEENTH = '13',
  POST_SECONDARY = 'PS',
  UG = 'UG', // ungraded
}

export type ClassGrades = keyof typeof VALID_CLASS_GRADES;
